import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import logoimg from '../Images/Easytaxexperts_logo.jpg';
import footerlogoimg from '../Images/irs.png';

// Updated icons
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const Footer = () => {
  const emaill = 'info@easytaxexperts.com';

  const handleEmailClick = () => {
    window.location.href = `mailto:${emaill}`;
  };

  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo & About */}
          <div className="footer-section">
            <div className="footer-logo-container">
              <img src={logoimg} alt="Easy Tax Experts" className="footer-logo" />
              
              
            </div>
            <p className="footer-description">
              Your trusted partner for comprehensive tax solutions and financial guidance. 
              We're committed to delivering exceptional service and maximizing your financial outcomes.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
            <li><Link to="/aboutus" className="footer-link">About Us</Link></li>
              <li><Link to="/signup" className="footer-link">Register Now</Link></li>
              <li><Link to="/refundstatus" className="footer-link">Refund Status</Link></li>
            
              <li><Link to="/price" className="footer-link">Pricing</Link></li>
                <li><Link to="/signup" className="footer-link">Register</Link></li>
                  <li><Link to="/login" className="footer-link">Login as Client</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-heading">Our Services</h4>
            <ul className="footer-links">
              <li><Link to="/federal" className="footer-link">Federal & State Filing</Link></li>
              <li><Link to="/representation" className="footer-link">Tax Representation</Link></li>
              <li><Link to="/itinpreparation" className="footer-link">ITIN Preparation</Link></li>
              <li><Link to="/taxplanning" className="footer-link">Advanced Tax Planning</Link></li>
              <li><Link to="/fbar" className="footer-link">FBAR & FATCA Compliance</Link></li>
              <li><Link to="/services" className="footer-link">Explore More...</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">Get in Touch</h4>
            <div className="footer-contact-info">
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <span>+1 (945)-358-4442</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>16192 Coastal Highway Lewis, DE 19958</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <span className="email" onClick={handleEmailClick}>{emaill}</span>
              </div>
            </div>
            <div className="social-section">
              <p className="social-title">Follow Us</p>
              <div className="social-icons">
                <a href="#" className="social-icon" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
                <a href="#" className="social-icon" aria-label="Facebook">
                  <FaFacebookF />
                </a>
                <a href="#" className="social-icon" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="#" className="social-icon" aria-label="Twitter">
                  <FaXTwitter />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 Easy Tax Experts | All Rights Reserved</p>
            <div className="footer-bottom-links">
            <Link to="/refundpolicy" className="footer-bottom-link">Refund Policy</Link>
              <span className="separator">|</span>
              <Link to="/privacypolicy" className="footer-bottom-link">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms" className="footer-bottom-link">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;